// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M18.2017 10.4039C19.2661 11.1987 19.2661 12.8013 18.2017 13.5961L10.1541 19.6047C8.85011 20.5783 7 19.6421 7 18.0087L7 5.99133C7 4.35786 8.85011 3.42165 10.1541 4.39526L18.2017 10.4039Z\" fill=\"#5A5C60\"/> </svg> ";
// Exports
module.exports = code;